import { Dropdown, Button } from "react-bootstrap";
import { useEditarConfigDeEnvelopeContext } from "../../../..";
import OrSpinner from "../../../../../../../../Components/Utils/OrSpinner";
import {
    AtualizarConfigEnvelopeDocumentoController,
    InserirConfigEnvelopeDocumentoController,
} from "../../../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoControllers";
import useArrayState from "../../../../../../../../hooks/useArrayState";
import useAsyncCallback from "../../../../../../../../hooks/useAsyncCallback";
import { IInserirConfigEnvelopeDocumento } from "../../../../../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";

interface IMenuSelecaoDeRubricasPorps {
    descricao: string;
    idVinculado?: number;
    configEnvelopeDocumentoBase: IInserirConfigEnvelopeDocumento;
    updateList: () => void;
}

export default function MenuSelecaoDeRubricas(
    props: IMenuSelecaoDeRubricasPorps
) {
    const { destinatariosConfigEnvelope, documentosConfigEnvelope } =
        useEditarConfigDeEnvelopeContext();

    const lstIdDestinatariosVinculados =
        documentosConfigEnvelope.lst.find(
            (doc) =>
                doc.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO === props.idVinculado
        )?.LISTA_ID_DESTINATARIO ?? ([] as Array<number>);

    const [destinatariosSelecionados, setDestinatariosSelecionados] =
        useArrayState({
            initialValue: lstIdDestinatariosVinculados,
        });

    const { execute: handleSalvarConfigButtonClick, loading: salvando } =
        useAsyncCallback(async function () {
            let promise: Promise<any>;
            if (props.idVinculado) {
                promise = AtualizarConfigEnvelopeDocumentoController({
                    ...props.configEnvelopeDocumentoBase,
                    ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO: props.idVinculado,
                    LISTA_ID_DESTINATARIO: destinatariosSelecionados,
                });
            } else {
                promise = InserirConfigEnvelopeDocumentoController({
                    ...props.configEnvelopeDocumentoBase,
                    LISTA_ID_DESTINATARIO: destinatariosSelecionados,
                });
            }
            await promise.then(props.updateList);
        });

    const loading =
        destinatariosConfigEnvelope.loading || documentosConfigEnvelope.loading;

    return (
        <Dropdown.Menu className="navi">
            <div className="navi-header font-weight-bold">Rúbricas</div>
            <Dropdown.Divider />
            <ul className="px-5">
                <OrSpinner
                    loading={loading}
                    wrapperLoadingClasses="w-100 d-flex justify-content-center"
                    loadingColor="primary"
                >
                    {destinatariosConfigEnvelope.lst.length ? (
                        destinatariosConfigEnvelope.lst?.map((dest) => (
                            <li
                                key={
                                    dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                                }
                                className="d-flex align-items-center g-3 my-2"
                            >
                                <input
                                    type="checkbox"
                                    checked={destinatariosSelecionados.some(
                                        (id) =>
                                            id ===
                                            dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                                    )}
                                    onChange={(e) => {
                                        if (e.target.checked)
                                            setDestinatariosSelecionados.add(
                                                dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                                            );
                                        else
                                            setDestinatariosSelecionados.remove(
                                                dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                                            );
                                    }}
                                    id={`check-config-${props.descricao}-dest-${dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO}`}
                                />
                                <label
                                    htmlFor={`check-config-${props.descricao}-dest-${dest.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO}`}
                                    className="ws-nowrap m-0"
                                >
                                    {dest.DS_DESTINATARIO}
                                </label>
                            </li>
                        ))
                    ) : (
                        <div className="text-center text-muted">
                            Nenhum Destinatário Vinculado
                        </div>
                    )}
                </OrSpinner>
            </ul>
            <Dropdown.Divider />
            <div className="navi-footer d-flex justify-content-end pt-1">
                <Button
                    variant="light-primary"
                    size="sm"
                    onClick={handleSalvarConfigButtonClick}
                    disabled={salvando}
                >
                    <OrSpinner loading={salvando} loadingSize="sm">
                        Salvar
                    </OrSpinner>
                </Button>
            </div>
        </Dropdown.Menu>
    );
}
